<template>
<div>
  <p class="has-text-weight-bold has-text-secondary">Route Bindings</p>
  <div v-if="!bindings.length">
    <p class="help">This route does not accept bindings.</p>
  </div>
  <div v-else>
    <div class="is-flex justify-between" v-for="binding in bindings" :key="binding.id">
      <span>{{ binding.class_name }}</span>
      <span :class="{
        'class-name': binding.type === 'model'
      }">
        {{ binding.type || 'var' | ucwords }}
      </span>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import { first } from 'lodash'

export default {

  computed: {
    ...mapGetters('route', [
      'route'
    ]),
    bindings() {
      return this.route.bindings
    }
  }

}
</script>